import React from 'react';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';

const TeamSummaryReportNetSale = () => {
    const distID = localStorage.getItem('distributorId');
    const { data, error, isLoaded } = GetRequest(`/Account/GetSalesTeamMember_NetBusiness`);

    // Early error and loading checks
    if (error) return <Error data="Distributor Summary" />;
    if (!isLoaded) return <Loading />;

    // Safe destructure with fallback
    const result = data?.result || {};
    const costCenterWiseNetBusinessValue = result.costCenterWiseNetBusinessValue || [];

    // Group by officer and category
    const groupedByOfficerAndCategory = costCenterWiseNetBusinessValue.reduce((acc, curr) => {
        const officer = curr.salesOfficerName || "Unknown Officer";
        if (!acc[officer]) acc[officer] = {};
        if (!acc[officer][curr.costCentreSalesCategoryName]) acc[officer][curr.costCentreSalesCategoryName] = [];
        acc[officer][curr.costCentreSalesCategoryName].push(curr);
        return acc;
    }, {});

    // Calculate grand total for all officers
    const grandTotal = costCenterWiseNetBusinessValue.reduce(
        (sum, item) => sum + item.netAmount,
        0
    );

    return (
        <section className="content">
            <div className="container-fluid px-2 px-md-4">

                {/* ===== Page Header ===== */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="fw-bold text-primary m-0">
                        <i className="fa fa-users me-2"></i>
                        Team Members Business
                    </h3>
                </div>

                {/* ===== Card: Net Business Value ===== */}
                <div className="card shadow-sm">
                    <div className="card-header bg-info text-white">
                        <h5 className="card-title mb-0">1. Net Business Value (Cost Centre-wise)</h5>
                    </div>
                    <div className="card-body table-responsive p-2">
                        <table className="table table-bordered table-hover table-sm align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Sales Category</th>
                                    <th className="text-center">Net Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(groupedByOfficerAndCategory).map(([officer, categories], officerIdx) => {
                                    // Total for this officer
                                    const officerTotal = Object.values(categories)
                                        .flat()
                                        .reduce((sum, item) => sum + item.netAmount, 0);

                                    return (
                                        <React.Fragment key={officerIdx}>
                                            {/* Officer Header Row */}
                                            <tr className="table-secondary">
                                                <td colSpan={2} className="fw-bold text-primary">
                                                    {officer}
                                                </td>
                                            </tr>

                                            {/* Categories under officer */}
                                            {Object.entries(categories).map(([category, items], catIdx) => {
                                                const totalNetAmount = items.reduce((sum, item) => sum + item.netAmount, 0);
                                                return (
                                                    <tr key={catIdx}>
                                                        <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                            {category}
                                                        </td>
                                                        <td className="text-center">
                                                            {Math.round(totalNetAmount).toLocaleString('en-IN')}
                                                        </td>
                                                    </tr>
                                                );
                                            })}

                                            {/* Officer Total */}
                                            <tr className="table-info fw-bold">
                                                <td className="text-end">Total for {officer}</td>
                                                <td className="text-center">
                                                    {Math.round(officerTotal).toLocaleString('en-IN')}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}

                                {/* ===== Grand Total ===== */}
                                <tr className="table-success fw-bold">
                                    <td className="text-end">Grand Total</td>
                                    <td className="text-center">
                                        {Math.round(grandTotal).toLocaleString('en-IN')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default TeamSummaryReportNetSale;
